// Libraries imports
import { Form, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';

type HeaderInfoProps = {
  processName: string;
  resourceName: string;
  register: any;
  errors: any;
};

export function HeaderInfo({ processName, resourceName, register, errors }: HeaderInfoProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{
        opacity: 1,
        y: 0,
        transition: {
          type: "spring",
          stiffness: 100,
          damping: 12,
          delay: 1 * 0.1
        }
      }}
      exit={{
        opacity: 0,
        y: -20,
        transition: { duration: 0.2 }
      }}
    >
      <Row className="mb-4">
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="nomeField">Nome do Recurso</Form.Label>
            <Form.Control
              id="nomeField"
              type="text"
              readOnly
              className="bg-light"
              {...register("name")}
              title="Nome do recurso"
              aria-label="Nome do recurso"
            />
            {errors.name && (
              <Form.Text className="text-danger">
                {errors.name.message}
              </Form.Text>
            )}
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="processoField">Processo Seletivo</Form.Label>
            <Form.Control
              id="processoField"
              type="text"
              readOnly
              className="bg-light"
              value={processName}
              title="Nome do processo seletivo"
              aria-label="Nome do processo seletivo"
            />
            <Form.Control type="hidden" {...register("processo_id")} />
            <Form.Control type="hidden" {...register("faculdade_id")} />
          </Form.Group>
        </Col>
      </Row>
    </motion.div>
  );
}
